import Vue from 'vue'
import moment from 'moment'

// show absence value
Vue.filter('showAbsence', function (value, absenceValue = '-') {
    return value || absenceValue
})

Vue.filter('bytesFormat', function (value) {
    if (value === null || value === undefined) return ''
    const length = value.toString().length
    if (length <= 3) {
        return (Math.round(value * 10) / 10).toString() + ' B'
    } else if (length <= 6) {
        return (Math.round(value / 1000 * 10) / 10).toString() + ' KB'
    } else {
        return (Math.round(value / 1000000 * 10) / 10).toString() + ' MB'
    }
})

Vue.filter('formatDate', function (value, format = 'L') {
    return moment(value).format(format)
})
